export const COMPETENCY_AREAS223 = [
  'literacy', 'economicUnderstanding', 'conceptConnection',
  'questionExpression', 'practiceRecord', 'familyCooperation', 'sustainedLearning',
] as const;
export type CompetencyArea223 = (typeof COMPETENCY_AREAS223)[number];

export const competencyLabels223: Record<CompetencyArea223, string> = {
  literacy: '문해력',
  economicUnderstanding: '경제 이해',
  conceptConnection: '개념 연결',
  questionExpression: '질문·표현',
  practiceRecord: '실천·기록',
  familyCooperation: '가족 협력',
  sustainedLearning: '지속 학습',
};

export const PASSPORT_SERVICES223 = ['mrm', 'lidia', 'bookquest', 'nexmap'] as const;
export type PassportService223 = (typeof PASSPORT_SERVICES223)[number];

export const passportServiceLabels223: Record<PassportService223, string> = {
  mrm: 'MY real Money',
  lidia: 'LIDIA',
  bookquest: 'BookQuest',
  nexmap: 'NEXMAP',
};

export const activityLabels223: Record<string, string> = {
  'article.read': '경제기사 탐험',
  'quiz.complete': '경제 퀴즈',
  'mission.complete': '생활 미션',
  'family.talk': '가족 경제 대화',
  'puzzle.piece': '퍼즐 조각',
  'igloo.stage': '이글루 단계',
  'assessment.complete': '문해력 평가',
  'answer.analysis': '답변 분석',
  'book.complete': '경제도서 완독',
  'quest.question': '독서 질문',
  'review.write': '독서 리뷰',
  'concept.map': '개념 지도',
  'concept.extract': '개념 추출',
};

export interface PassportActivity223 {
  serviceId: PassportService223;
  activityType: string;
  count: number;
}

export interface PassportCertificate223 {
  certificateId: string;
  issuer: PassportService223 | 'nexpa';
  title: string;
  criteria: string;
  designTheme: string;
}

/**
 * Every line names where it came from. A passport line without a source cannot
 * be judged by the reader, so the label always pairs the two.
 */
export function activityLine223(activity: PassportActivity223): string {
  const label = activityLabels223[activity.activityType] ?? activity.activityType;
  return `${label} ${activity.count}회`;
}

export function sourceLabel223(serviceId: PassportService223 | 'nexpa'): string {
  return serviceId === 'nexpa' ? 'NEXPA' : passportServiceLabels223[serviceId];
}

/**
 * Areas the user has evidence in, with per-service counts kept separate.
 * There is deliberately no function that reduces this to one number: the
 * services score on different scales, so a combined figure would mislead.
 */
export function areasWithEvidence223(competency: Record<string, { total: number }>): CompetencyArea223[] {
  return COMPETENCY_AREAS223.filter((area) => (competency[area]?.total ?? 0) > 0);
}

export function servicesInPassport223(activities: PassportActivity223[]): PassportService223[] {
  return PASSPORT_SERVICES223.filter((serviceId) => activities.some((item) => item.serviceId === serviceId));
}
